var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showError, showWarning } from '@spike/notifications-action';
import Axios from 'axios';
import { BLOCK_CALENDAR_CLEAR_ALERTS_ACTION_TYPE, BLOCK_CALENDAR_COUNT_RECURRENT_START_ACTION_TYPE, BLOCK_CALENDAR_COUNT_RECURRENT_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_DELETE_START_ACTION_TYPE, BLOCK_CALENDAR_DELETE_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_ERROR_ACTION_TYPE, BLOCK_CALENDAR_FETCH_ALERTS_START_ACTION_TYPE, BLOCK_CALENDAR_FETCH_ALERTS_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_FETCH_START_ACTION_TYPE, BLOCK_CALENDAR_FETCH_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_GET_START_ACTION_TYPE, BLOCK_CALENDAR_GET_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_ADD_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_DELETE_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_UPDATE_ACTION_TYPE, BLOCK_CALENDAR_RESET_ACTION_TYPE, BLOCK_CALENDAR_SAVE_START_ACTION_TYPE, BLOCK_CALENDAR_SAVE_SUCCESS_ACTION_TYPE, } from './BlockCalendarActionsTypes';
import { convertToAlerts, convertToBlockCalendar, convertToBlocksCalendar, convertToRecurrent, } from './BlockCalendarConverter';
import isEmpty from 'lodash/isEmpty';
var blockCalendarUrl = 'block_calendars';
var blockCalendarAlertsUrl = 'check_block_calendar_alerts';
var countRecurrentsUrl = 'block_calendar/count';
var dateFormat = 'YYYY-MM-DD';
var isLastFetchRequest = function (requestToken, getState) {
    return getState().blockCalendar.requestTokens.fetch === requestToken;
};
var isLastGetRequest = function (requestToken, getState) {
    return getState().blockCalendar.requestTokens.get === requestToken;
};
var isLastAlertsRequest = function (requestToken, getState) {
    return getState().blockCalendar.requestTokens.alerts === requestToken;
};
var isLastCountRecurrentRequest = function (requestToken, getState) {
    return getState().blockCalendar.requestTokens.recurrent === requestToken;
};
var matchFilter = function (block, filter) {
    return filter.from && filter.to && block.start.isBetween(filter.from, filter.to, 'dates', '[]');
};
var getLocalAction = function (block, filter, currentBlocks) {
    var match = matchFilter(block, filter);
    if (!match) {
        return 'none';
    }
    else if (currentBlocks.some(function (currentBlock) { return currentBlock.id === block.id; })) {
        return 'update';
    }
    else {
        return 'add';
    }
};
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var fetchThunk = function (apiClientWrapper, startDate, endDate, calendarId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchStart(requestToken));
                    url = "".concat(blockCalendarUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start_date=").concat(startDate.format(dateFormat), "&end_date=").concat(endDate.format(dateFormat), "&calendar_id=").concat(calendarId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetchRequest(requestToken, getState) &&
                        dispatch(fetchSuccess(response.data, startDate.clone(), endDate.clone(), apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError('Error fetching blocks calendar.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getThunk = function (apiClientWrapper, blockCalendarId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(getStart(requestToken));
                    url = "".concat(blockCalendarUrl, "/").concat(blockCalendarId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastGetRequest(requestToken, getState) &&
                        dispatch(getSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError('Error getting block calendar.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveThunk = function (apiClientWrapper, block) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiMethod, body, response, apiError_3;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(saveStart());
                    url = block.id
                        ? "".concat(blockCalendarUrl, "/").concat(block.id, "?marketplace_id=").concat(apiClientWrapper.marketplaceId)
                        : "".concat(blockCalendarUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    apiMethod = block.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    body = {
                        marketplace_id: apiClientWrapper.marketplaceId,
                        id: block.id,
                        uuid: block.uuid,
                        calendar_id: block.calendarId,
                        start: block.start.toDate(),
                        end: block.end.toDate(),
                        staff_id: block.staff.id,
                        title: isEmpty(block.title) ? null : block.title,
                        description: isEmpty(block.description) ? null : block.description,
                        schedule_frequency_id: (_b = (_a = block.frequency) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
                    };
                    return [4 /*yield*/, apiMethod(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _d.sent();
                    dispatch(saveSuccess(response.data.block_calendar, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    handleWarnings((_c = response.data.errors) !== null && _c !== void 0 ? _c : [], dispatch);
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _d.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError('Error saving block calendar.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteThunk = function (apiClientWrapper, blockId, deleteRecurrent) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart());
                    url = "".concat(blockCalendarUrl, "/").concat(blockId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&recurring=").concat(deleteRecurrent);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(blockId));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError('Error deleting block calendar.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var countRecurrentThunk = function (apiClientWrapper, blockId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, recurrent, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(countRecurrentStart(requestToken));
                    url = "".concat(countRecurrentsUrl, "/").concat(blockId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    recurrent = convertToRecurrent(response.data, apiClientWrapper.masterData);
                    isLastCountRecurrentRequest(requestToken, getState) &&
                        dispatch(countRecurrentSuccess(blockId, recurrent.frequency, recurrent.remaining, recurrent.total));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        dispatch(showError('Error counting recurrent blocks calendar.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var clearAlertsThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(clearAlerts('clear'));
            return [2 /*return*/];
        });
    }); };
};
export var fetchAlertsThunk = function (apiClientWrapper, startDate, endDate, staffId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchAlertsStart(requestToken));
                    url = "".concat(blockCalendarAlertsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start_date=").concat(startDate.toISOString(), "&end_date=").concat(endDate.toISOString(), "&staff_id=").concat(staffId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastAlertsRequest(requestToken, getState) && dispatch(fetchAlertsSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        dispatch(showError('Error fetching blocks calendar alerts.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteLocalThunk = function (blockIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(deleteLocal(blockIds));
            return [2 /*return*/];
        });
    }); };
};
export var updateLocalThunk = function (blockDto, timeZone, masterData) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var block, localAction;
        return __generator(this, function (_a) {
            block = convertToBlockCalendar(blockDto, timeZone, masterData);
            localAction = getLocalAction(block, getState().blockCalendar.filter, getState().blockCalendar.blocks);
            if (localAction === 'update') {
                dispatch(updateLocal(block));
            }
            else if (localAction === 'add') {
                dispatch(addLocal(block));
            }
            return [2 /*return*/];
        });
    }); };
};
var fetchStart = function (requestToken) {
    return {
        type: BLOCK_CALENDAR_FETCH_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchSuccess = function (blocks, from, to, timeZone, masterData) {
    return {
        type: BLOCK_CALENDAR_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            blocks: convertToBlocksCalendar(blocks, timeZone, masterData),
            from: from.clone().startOf('day'),
            to: to.clone().endOf('day'),
        },
    };
};
var getStart = function (requestToken) {
    return {
        type: BLOCK_CALENDAR_GET_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var getSuccess = function (block, timeZone, masterData) {
    return {
        type: BLOCK_CALENDAR_GET_SUCCESS_ACTION_TYPE,
        payload: {
            block: convertToBlockCalendar(block, timeZone, masterData),
        },
    };
};
var saveStart = function () {
    return {
        type: BLOCK_CALENDAR_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (block, timeZone, masterData) {
    return {
        type: BLOCK_CALENDAR_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            block: convertToBlockCalendar(block, timeZone, masterData),
        },
    };
};
var deleteStart = function () {
    return {
        type: BLOCK_CALENDAR_DELETE_START_ACTION_TYPE,
    };
};
var deleteSuccess = function (blockId) {
    return {
        type: BLOCK_CALENDAR_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            blockId: blockId,
        },
    };
};
var countRecurrentStart = function (requestToken) {
    return {
        type: BLOCK_CALENDAR_COUNT_RECURRENT_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var countRecurrentSuccess = function (blockId, frequency, remaining, total) {
    return {
        type: BLOCK_CALENDAR_COUNT_RECURRENT_SUCCESS_ACTION_TYPE,
        payload: {
            blockId: blockId,
            frequency: frequency,
            remaining: remaining,
            total: total,
        },
    };
};
var clearAlerts = function (requestToken) {
    return {
        type: BLOCK_CALENDAR_CLEAR_ALERTS_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchAlertsStart = function (requestToken) {
    return {
        type: BLOCK_CALENDAR_FETCH_ALERTS_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchAlertsSuccess = function (alerts) {
    return {
        type: BLOCK_CALENDAR_FETCH_ALERTS_SUCCESS_ACTION_TYPE,
        payload: {
            alerts: convertToAlerts(alerts),
        },
    };
};
var deleteLocal = function (blockIds) {
    return {
        type: BLOCK_CALENDAR_LOCAL_DELETE_ACTION_TYPE,
        payload: {
            blockIds: blockIds,
        },
    };
};
var updateLocal = function (block) {
    return {
        type: BLOCK_CALENDAR_LOCAL_UPDATE_ACTION_TYPE,
        payload: {
            block: block,
        },
    };
};
var addLocal = function (block) {
    return {
        type: BLOCK_CALENDAR_LOCAL_ADD_ACTION_TYPE,
        payload: {
            block: block,
        },
    };
};
var reset = function () {
    return {
        type: BLOCK_CALENDAR_RESET_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: BLOCK_CALENDAR_ERROR_ACTION_TYPE,
    };
};
var handleWarnings = function (errors, dispatch) {
    return errors.forEach(function (errorMessage) { return dispatch(showWarning(errorMessage)); });
};
